import { Component, Input }   from '@angular/core';
import { BlockUI, NgBlockUI } from 'ng-block-ui';
import { NgForm }             from '@angular/forms';
import { TranslateService }   from '@ngx-translate/core';
import { UIRouter }           from '@uirouter/angularjs';

import { CapricornService }         from './capricorn.service';
import { CompanyIntegrationsModel } from '../companies/models/company.integrations';
import { CompanyService }           from '../companies/company.service';
import { ConfirmService }           from '../messages/confirm/confirm.service';
import { MessagesService }          from '../messages/messages.service';

@Component({
  selector   : 'wor-capricorn-settings',
  template: require('./capricorn.settings.component.html')
})
export class CapricornSettingsComponent {
  @BlockUI('capricornBlock') block : NgBlockUI;

  @Input() integrations: CompanyIntegrationsModel;

  title : string = this.capricornService.title;

  constructor (
    private capricornService: CapricornService,
    public  companyService  : CompanyService,
    private confirmService  : ConfirmService,
    private messagesService : MessagesService,
    private router          : UIRouter,
    private translateService: TranslateService
  ) {}

  activate () : void {
    this.confirmService.generic(this.translateService.instant('JS_SPACE.INTEGRATIONS.ACTIVATE', {
      name: this.title
    }))
    .then(() => this.capricornService.activate())
    .then(() => {
      this.messagesService.show(this.translateService.instant('JS_SPACE.INTEGRATIONS.ACTIVATED', {
        name: this.title
      }), 'success');

      this.router.stateService.reload();
    })
    .catch(error => this.messagesService.error(error));
  }

  deactivate () : void {
    this.confirmService.generic(this.translateService.instant('JS_SPACE.INTEGRATIONS.REMOVE', {
      name: this.title
    }))
    .then(() => this.capricornService.deactivate())
    .then(() => {
      this.messagesService.show(this.translateService.instant('JS_SPACE.INTEGRATIONS.REMOVED', {
        name: this.title
      }), 'success');

      this.router.stateService.reload();
    })
    .catch(error => this.messagesService.error(error));
  }

  save ( form : NgForm ) : void {
    this.block.start(this.translateService.instant('GENERAL_SPACE.MESSAGE.SAVING'));

    this.capricornService.saveSettings(this.integrations)
    .then(() => {
      this.messagesService.show(this.translateService.instant('JS_SPACE.MESSAGES.SAVED.SAVE_SUCCESSFUL'), 'success');

      this.router.stateService.reload();
    })
    .catch(error => this.messagesService.error(error))
    .finally(() => this.block.stop());
  }
}
